import axios from 'axios';

import Ramses from '../base/ramses';

import UserOsirisService from '../credit_platform/access';

import methods from '@/enums/methods';

// axios.defaults.headers.common.Authorization = `Bearer ${sessionStorage.getItem('token')}`;

class UserService extends Ramses {
    authenticate() {
        return this.fetch({
            url: 'users/authenticate',
            method: methods.POST,
        });
    }

    me() {
        return this.fetch({
            url: 'users/me',
        });
    }

    logout() {
        return this.fetch({
            url: 'users/logout',
            method: methods.POST,
        });
    }

    forgotPassword({ email }) {
        return this.fetch({
            data: { email },
            url: 'users/recover-password',
            method: methods.POST,
        });
    }

    changePassword({ password, new_password }) {
        return this.fetch({
            data: { password, new_password },
            method: methods.PUT,
            url: 'users/change-password',
        });
    }

    verifyHash(hash) {
        return this.fetch({
            url: `users/verify-hash/${hash}`,
        });
    }

    verify2FA(data) {
        return this.fetch({
            url: 'users/two-factor-authentication',
            data,
            method: methods.POST,
        });
    }

    resetPassword({ new_password }, hash) {
        return this.fetch({
            data: { new_password },
            url: `users/reset-password/${hash}`,
            method: methods.PUT,
        });
    }

   async signIn(email, password) {
    try {
        const responseLogin = await this.fetch({
            url: 'users/login',
            data: { email, password },
            method: methods.POST,
        });

        const { token } = responseLogin.data;
        sessionStorage.setItem('token', token);

        return responseLogin;
    } catch ({ response }) {
        return response;
    }
  }
}

export default new UserService();
